import { useAppSelector } from "@/redux/store.ts";
import { SmartNumberDescriptor } from "@/types";

export default function useModelCode() {
    const smartNumberMapping = useAppSelector((state) => state.smartNumber.mapping);

    if (!smartNumberMapping) return null;

    return smartNumberMapping[SmartNumberDescriptor.SubFamily];
}
